export const actionTypes = {
  SELECT_CATALOG_OFFICE: "SELECT_CATALOG_OFFICE",
  MODIFY_CATALOG_SELECTED_USERS: "MODIFY_CATALOG_SELECTED_USERS",
  OFFICE_CATALOG_REQUEST: "OFFICE_CATALOG_REQUEST",
  OFFICE_CATALOG_REQUEST_SUCCESS: "OFFICE_CATALOG_REQUEST_SUCCESS",
  OFFICE_CATALOG_REQUEST_FAILURE: "OFFICE_CATALOG_REQUEST_FAILURE",
  ENTITLEMENT_CATALOG_REQUEST: "ENTITLEMENT_CATALOG_REQUEST",
  ENTITLEMENT_CATALOG_REQUEST_SUCCESS: "ENTITLEMENT_CATALOG_REQUEST_SUCCESS",
  ENTITLEMENT_CATALOG_REQUEST_FAILURE: "ENTITLEMENT_CATALOG_REQUEST_FAILURE",
  OFFICE_ENTITLEMENT_CATALOG_REQUEST: "OFFICE_ENTITLEMENT_CATALOG_REQUEST",
  OFFICE_ENTITLEMENT_CATALOG_REQUEST_SUCCESS:
    "OFFICE_ENTITLEMENT_CATALOG_REQUEST_SUCCESS",
  OFFICE_ENTITLEMENT_CATALOG_REQUEST_FAILURE:
    "OFFICE_ENTITLEMENT_CATALOG_REQUEST_FAILURE",
  CHAIN_ENTITLEMENT_REQUEST: "CHAIN_ENTITLEMENT_REQUEST",
  CHAIN_ENTITLEMENT_REQUEST_SUCCESS: "CHAIN_ENTITLEMENT_REQUEST_SUCCESS",
  CHAIN_ENTITLEMENT_REQUEST_FAILURE: "CHAIN_ENTITLEMENT_REQUEST_FAILURE",
  MODIFY_CATALOG_DELETED_ENTITLEMENTS: "MODIFY_CATALOG_DELETED_ENTITLEMENTS",
  MODIFY_CATALOG_TOTAL_ENTITLEMENTS: "MODIFY_CATALOG_TOTAL_ENTITLEMENTS",
  MODIFY_CATALOG_PREV_ENTITLEMENTS: "MODIFY_CATALOG_PREV_ENTITLEMENTS",
  MODIFY_CATALOG_ADDED_ENTITLEMENTS: "MODIFY_CATALOG_ADDED_ENTITLEMENTS",
  CREATE_CATALOG_REQUEST: "CREATE_CATALOG_REQUEST",
  CREATE_CATALOG_REQUEST_SUCCESS: "CREATE_CATALOG_REQUEST_SUCCESS",
  CREATE_CATALOG_REQUEST_FAILURE: "CREATE_CATALOG_REQUEST_FAILURE",
  RESET_STATE_CATALOG: "RESET_STATE_CATALOG",
  RESET_CHAIN_ENTITLEMENTS: "RESET_CHAIN_ENTITLEMENTS",
  GLOBAL_CATALOG_REQUEST: "GLOBAL_CATALOG_REQUEST",
  GLOBAL_CATALOG_REQUEST_SUCCESS: "GLOBAL_CATALOG_REQUEST_SUCCESS",
  GLOBAL_CATALOG_REQUEST_FAILURE: "GLOBAL_CATALOG_REQUEST_FAILURE",

  SET_SHOW_GLOBAL_CATALOG_FILTER_MODAL: "SET_SHOW_GLOBAL_CATALOG_FILTER_MODAL",
};

export const officeRequest = () => ({
  type: actionTypes.OFFICE_CATALOG_REQUEST,
});

export const officeRequestSuccess = (payload: any) => ({
  type: actionTypes.OFFICE_CATALOG_REQUEST_SUCCESS,
  payload,
});

export const officeRequestFailure = (err: any) => ({
  type: actionTypes.OFFICE_CATALOG_REQUEST_FAILURE,
  err,
});

export const selectOffice = (id: string) => ({
  type: actionTypes.SELECT_CATALOG_OFFICE,
  id,
});

export const modifySelectedUsers = (selectedUsers: []) => ({
  type: actionTypes.MODIFY_CATALOG_SELECTED_USERS,
  selectedUsers,
});

export const entitlementRequest = (obj: any) => ({
  type: actionTypes.ENTITLEMENT_CATALOG_REQUEST,
  obj,
});

export const entitlementRequestSuccess = (payload: any) => ({
  type: actionTypes.ENTITLEMENT_CATALOG_REQUEST_SUCCESS,
  payload,
});

export const entitlementRequestFailure = (err: any) => ({
  type: actionTypes.ENTITLEMENT_CATALOG_REQUEST_FAILURE,
  err,
});

export const officeEntitlementRequest = (id: string | number) => ({
  type: actionTypes.OFFICE_ENTITLEMENT_CATALOG_REQUEST,
  id,
});

export const officeEntitlementRequestSuccess = (payload: any) => ({
  type: actionTypes.OFFICE_ENTITLEMENT_CATALOG_REQUEST_SUCCESS,
  payload,
});

export const officeEntitlementRequestFailure = (err: any) => ({
  type: actionTypes.OFFICE_ENTITLEMENT_CATALOG_REQUEST_FAILURE,
  err,
});

export const chainEntitlementRequest = (payload: any[]) => ({
  type: actionTypes.CHAIN_ENTITLEMENT_REQUEST,
  payload,
});

export const chainEntitlementRequestSuccess = (payload: any) => ({
  type: actionTypes.CHAIN_ENTITLEMENT_REQUEST_SUCCESS,
  payload,
});

export const chainEntitlementRequestFailure = (err: any) => ({
  type: actionTypes.CHAIN_ENTITLEMENT_REQUEST_FAILURE,
  err,
});

export const modifyDeletedEntitlements = (deletedEntitlements: []) => ({
  type: actionTypes.MODIFY_CATALOG_DELETED_ENTITLEMENTS,
  deletedEntitlements,
});

export const modifyTotalEntitlements = (totalEntitlements: []) => ({
  type: actionTypes.MODIFY_CATALOG_TOTAL_ENTITLEMENTS,
  totalEntitlements,
});

export const modifyPrevEntitlements = (prevEntitlements: []) => ({
  type: actionTypes.MODIFY_CATALOG_PREV_ENTITLEMENTS,
  prevEntitlements,
});

export const modifyAddedEntitlements = (addedEntitlements: []) => ({
  type: actionTypes.MODIFY_CATALOG_ADDED_ENTITLEMENTS,
  addedEntitlements,
});

export const resetStatesCatalog = () => ({
  type: actionTypes.RESET_STATE_CATALOG,
});

export const createRequest = (payload: {}) => ({
  type: actionTypes.CREATE_CATALOG_REQUEST,
  payload,
});

export const createRequestSuccess = (payload: any) => ({
  type: actionTypes.CREATE_CATALOG_REQUEST_SUCCESS,
  payload,
});

export const createRequestFailure = (err: any) => ({
  type: actionTypes.CREATE_CATALOG_REQUEST_FAILURE,
  err,
});

export const resetChainEntitlements = () => ({
  type: actionTypes.RESET_CHAIN_ENTITLEMENTS,
});

export const setShowGlobalCatalogFilterModalAction = (payload: any) => ({
  type: actionTypes.SET_SHOW_GLOBAL_CATALOG_FILTER_MODAL,
  payload,
});

export const getPaginatedGlobalCatalogAction = (payload: any) => ({
  type: actionTypes.GLOBAL_CATALOG_REQUEST,
  payload,
});
export const getPaginatedGlobalCatalogActionSuccess = (payload: any) => ({
  type: actionTypes.GLOBAL_CATALOG_REQUEST_SUCCESS,
  payload,
});
export const getPaginatedGlobalCatalogActionFailure = (payload: any) => ({
  type: actionTypes.GLOBAL_CATALOG_REQUEST_FAILURE,
  payload,
});
